import { SyntheticEvent } from "react";
import { FormControl, FormErrorMessage, FormLabel, Input, Stack } from "@chakra-ui/react";

import { useSMSFormState, useSMSFormStateReaction } from "./hooks";
import { isNewAuthorization } from "../../../../store/authorizationStore";

export function SMSForm() {
  const smsForm = useSMSFormState();
  useSMSFormStateReaction();

  const handleChange = (e: SyntheticEvent<HTMLInputElement>) => {
    smsForm.setCode(e.currentTarget.value);
    smsForm.setErrorMessage("");
  };

  return (
    <Stack spacing={4}>
      <FormControl isInvalid={!!smsForm.errorMessage}>
        <FormLabel>
          Код из SMS
        </FormLabel>
        <Input
          name="otp"
          autoComplete="one-time-code"
          value={smsForm.code}
          maxLength={isNewAuthorization() ? 6 : 4}
          autoFocus
          onChange={handleChange}
          inputMode="numeric"
          _hover={{ borderColor: smsForm.errorMessage ? "red.500" : "purple.500" }}
          _focus={{ borderColor: smsForm.errorMessage ? "red.500" : "purple.500" }}
        />
        <FormErrorMessage>{smsForm.errorMessage}</FormErrorMessage>
      </FormControl>
    </Stack>
  );
}
